
import React from "react";
import { Dumbbell } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

interface ExerciseCardProps {
  exercise: any;
}

function ExerciseCardComponent({ exercise }: ExerciseCardProps) {
  // Format rest seconds into a more readable format
  const formatRestTime = (seconds: number) => {
    if (!seconds) return null;
    if (seconds < 60) return `${seconds}s`;
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return remainingSeconds > 0 
      ? `${minutes}m ${remainingSeconds}s` 
      : `${minutes}m`;
  };

  // Get notes content - prioritize exercise_notes, then fall back to notes
  const notesContent = exercise.exercise_notes || exercise.notes || null;

  return (
    <Card className="bg-white/10 border-white/20">
      <CardContent className="p-3">
        <div className="flex justify-between items-start">
          <div className="flex items-center gap-2">
            <Dumbbell className="h-4 w-4 text-white/70" />
            <h4 className="font-medium text-white">{exercise.name}</h4>
          </div>
          <div className="text-sm text-white/70">
            {exercise.sets && (
              <span>
                {exercise.sets} x {exercise.reps || "-"}
              </span>
            )}
            {exercise.intensity && (
              <span className="ml-2">{exercise.intensity}</span>
            )}
            {exercise.rest_seconds && (
              <span className="ml-2">Rest: {formatRestTime(exercise.rest_seconds)}</span>
            )}
          </div>
        </div>
        {notesContent ? (
          <p className="mt-2 text-sm text-white/70">{notesContent}</p>
        ) : (
          <p className="mt-2 text-sm text-white/70 italic">No notes available</p>
        )}
      </CardContent>
    </Card>
  );
}

// Memoize since exercise data rarely changes after initial render
export const ExerciseCard = React.memo(ExerciseCardComponent);
